var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenInNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: 16,
    height: 16,
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "open_in_new"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "open_in_new_2",
    d: "M3.59993 13.6C3.26993 13.6 2.98743 13.4825 2.75243 13.2475C2.51743 13.0125 2.39993 12.73 2.39993 12.4V3.60002C2.39993 3.27002 2.51743 2.98752 2.75243 2.75252C2.98743 2.51752 3.26993 2.40002 3.59993 2.40002H7.99993V3.60002H3.59993V12.4H12.3999V8.00002H13.5999V12.4C13.5999 12.73 13.4824 13.0125 13.2474 13.2475C13.0124 13.4825 12.7299 13.6 12.3999 13.6H3.59993ZM6.44993 10.4L5.59993 9.55002L11.5499 3.60002H9.59993V2.40002H13.5999V6.40002H12.3999V4.45002L6.44993 10.4Z",
    fill: "url(#paint0_linear_0_209)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_209",
    x1: 2.33188,
    y1: 2.88783,
    x2: 15.5364,
    y2: 7.35558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/open_in_new.3e2b6294fb6ae1d3284dd270223a7ca0.svg";
export { ForwardRef as ReactComponent };